const Home = () => import('@/views/home/components/Home')
const ChangeProfilePassword = () => import('@/views/home/components/ChangeProfilePassword')
const ChangeProfilePriceAdd = () => import('@/views/home/components/ChangeProfilePriceAdd')
const HealthCheck = () => import('@/views/home/components/HealthCheck')

export default [
  {
    name: 'home',
    path: '/',
    component: Home,
    meta: {
      requiresAuth: true,
    },
  },
  {
    name: 'profile.password',
    path: '/alterar-senha-perfil',
    component: ChangeProfilePassword,
    meta: {
      requiresAuth: true,
    },
  },
  {
    name: 'profile.configPrice',
    path: '/atualizar-percentual',
    component: ChangeProfilePriceAdd,
    meta: {
      requiresAuth: true,
    },
  },
  {
    name: 'profile.healthcheck',
    path: '/healthcheck',
    component: HealthCheck,
    meta: {
      requiresAuth: true,
    },
  }
]
